import { useMemo } from 'react';
import { cirrusApi } from 'App/rtk';
import { FreeShippingEndpoints } from '../freeShippingApi';

interface UseFreeShippingItemStatusProps {
  id: string | undefined;
}

interface UseFreeShippingItemStatusResult {
  status: boolean | undefined;
  isLoading: boolean;
}

export function useFreeShippingItemStatus({
  id,
}: UseFreeShippingItemStatusProps): UseFreeShippingItemStatusResult {
  const queryResult = cirrusApi.endpoints[
    FreeShippingEndpoints.getFreeShippingsList
  ].useQuery({ search: id }, { skip: !id });

  const { data, isLoading } = queryResult;

  const status = useMemo(() => {
    if (!data?.results || !id) return undefined;

    const freeShipping = data.results.find((item) => item.id === id);
    return freeShipping?.enable;
  }, [data?.results, id]);

  return {
    status,
    isLoading,
  };
}
